import axios from "axios";
import Recase from "recase";

const recase = Recase.create({});

function normaliseResponseData(data) {
  return recase.camelCopy(data);
}

export default function request(config) {
  const mergedConfig = {
    ...config,
    params: config.params ? recase.snakeCopy(config.params) : null,
    data: config.data ? recase.snakeCopy(config.data) : null
  };

  return axios(mergedConfig)
    .then(resp => normaliseResponseData(resp.data))
    .catch(error => {
      if (error.response) {
        error.response.data = normaliseResponseData(error.response.data); // eslint-disable-line
      }
      throw error;
    });
}
